import { Injectable, inject } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { ValidationPatterns } from "@app/shared/validators/ValidationPatterns";
import { passwordRepeatValidator } from "@app/shared/validators/password-repeat/passwordRepeatValidator.directive";
import { RegistrationFormGroupModel } from "@app/shared/models/registration-form-group.model";
import { BookingStepsFormService } from "@app/shared/services/booking-steps-form/booking-steps-form.service";


@Injectable({ providedIn: 'root' })

export class CustomerRegistrationFormService {

  public validPasswordExpression = ValidationPatterns.validPasswordExpression;
  private readonly fb = inject(FormBuilder);
  private bookingStepsFormService = inject(BookingStepsFormService);

  public buildCustomerRegistrationForm(): RegistrationFormGroupModel {
    const registrationForm = this.fb.group({
      customerData: this.bookingStepsFormService.buildCustomerDataFormGroup(),
      password: ['', { validators: [Validators.required, Validators.pattern(this.validPasswordExpression), Validators.minLength(8), Validators.maxLength(20)] }],
      passwordRepeat: ['', { validators: [Validators.required, Validators.pattern(this.validPasswordExpression), Validators.maxLength(20)] }],
      salonOnlineBookingTermsAndConditionsUrl: [null]
    }, { validators: passwordRepeatValidator });
    return registrationForm;
  };
}
